module.exports = __webpack_public_path__ + "img/id.e963b60e.png";